import { ActivatedRoute, Router } from '@angular/router';
import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import { RegistrationService } from '../registration/registration-service/registration.service';
import { NavbarComponent } from '../shared/components/navbar/navbar.component';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-registration-welcome',
  templateUrl: './registration-welcome.component.html',
  styleUrls: ['./registration-welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavbarComponent, MatIcon],
})
export class RegistrationWelcomeComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private registrationServce = inject(RegistrationService);

  readonly schoolInfo = signal<any>(null);
  schoolCode: string;

  constructor() {
    this.route.params.subscribe((params) => {
      this.schoolCode = params.schoolCode;
      this.registrationServce.getSchoolInfo(this.schoolCode).subscribe(
        (res: any) => {
          this.schoolInfo.set(res.data);
        },
        () => {
          this.router.navigate(['/not-found']);
        },
      );
    });
  }

  onContinue(): void {
    this.router.navigateByUrl('/' + this.schoolCode + '/admission');
  }

  redirectToWelcome(): void {
    this.router.navigate(['/', this.schoolCode]);
  }
}
